import { CardElement } from 'react-stripe-elements'
import { connect, ErrorMessage } from 'formik'

// https://github.com/stripe/react-stripe-elements/issues/286

export const StripeCCFields = connect(({ formik }) => {
  if (formik.values.payment_method !== 'stripe_cc') return null

  if (formik.values._stripe === undefined) {
    return <div className='donations-form-stripe-fields mb-6'>
      <h4>{I18n.t('donate.stripe_cc_fields.headline')}</h4>
      <p>{I18n.t('donate.errors.stripe_cc_unavailable')}</p>
    </div>
  }

  const handleChange = (event) => {
    if (event.error) {
      formik.setFieldTouched('stripe_token', true, false)
      formik.setFieldError('stripe_token', I18n.t(`donate.errors.stripe_cc_${event.error.code}`))
      formik.setSubmitting(false)
    } else {
      formik.setFieldTouched('stripe_token', true, false)
      formik.setFieldError('stripe_token', undefined)
    }
  }

  return <div className='donations-form-stripe-fields mb-6'>
    <h4>{I18n.t('donate.stripe_cc_fields.headline')}*</h4>
    <CardElement onChange={handleChange} id='card-element' hidePostalCode style={stripeStyle} />
    <ErrorMessage name='stripe_token' component='span' className='help-inline' />
  </div>
})

const stripeStyle = {
  base: {
    color: '#32325d',
    lineHeight: '18px',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
}
